import React from 'react';
import { textOverflow } from 'scy/utils.mod.scss';
import { SecondaryBody } from 'scy/text';

export default function Subtitle({ subtitle, includeItemProps }) {
  return (
    <SecondaryBody
      className={textOverflow}
      itemProp={includeItemProps ? 'description' : undefined}
    >
      {subtitle}
    </SecondaryBody>
  );
}
